import React from 'react';
import Footer from '../components/Footer';

export default function Privacypolicy() {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Privacy Policy</h1>
      <p className="text-muted">
        This is a general-purpose sample Privacy Policy for our company, <strong>Slipmart</strong>. It assumes our company is an e-commerce business collecting customer data through our website.
      </p>
      

      <hr />

      <p><strong>Effective Date:</strong> August 4, 2025</p>
      <p><strong>Last Updated:</strong> August 4, 2025</p>

      <p>
        At <strong>Slipmart</strong>, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, store, and share your information when you visit our website or interact with our services.
      </p>

      <hr />

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information:</p>

      <h5>a. Personal Information:</h5>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Shipping and billing address</li>
        <li>Phone number</li>
        <li>Payment details (processed securely through third-party providers)</li>
      </ul>

      <h5>b. Non-Personal Information:</h5>
      <ul>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device information</li>
        <li>Pages visited</li>
        <li>Referral source</li>
      </ul>

      <h5>c. Cookies and Tracking Technologies:</h5>
      <p>
        We use cookies and similar tracking technologies to improve your browsing experience, remember your preferences, and analyze website traffic.
      </p>

      <hr />

      <h2>2. How We Use Your Information</h2>
      <p>We may use your information to:</p>
      <ul>
        <li>Process and fulfill your orders</li>
        <li>Communicate with you about orders, products, and promotions</li>
        <li>Improve and personalize our website and services</li>
        <li>Detect and prevent fraudulent activities</li>
        <li>Comply with legal obligations</li>
      </ul>

      <hr />

      <h2>3. How We Share Your Information</h2>
      <p>We do <strong>not sell</strong> your personal information. However, we may share your data with:</p>
      <ul>
        <li><strong>Service providers</strong> (e.g., payment processors, shipping carriers, marketing platforms)</li>
        <li><strong>Legal authorities</strong>, if required to comply with applicable laws or respond to legal requests</li>
      </ul>
      <p>All third-party services we use are contractually obligated to protect your data.</p>

      <hr />

      <h2>4. Data Retention</h2>
      <p>
        We retain your personal information for as long as necessary to fulfill the purposes described in this policy or as required by law.
      </p>

      <hr />

      <h2>5. Your Rights</h2>
      <p>Depending on your location, you may have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Correct or delete your information</li>
        <li>Object to or restrict certain data processing</li>
        <li>Withdraw your consent at any time</li>
      </ul>
      <p>
        To exercise your rights, please contact us at{' '}
        <a href="mailto:privacy@slipmart.com">privacy@slipmart.com</a>.
      </p>

      <hr />

      <h2>6. Security</h2>
      <p>
        We implement appropriate technical and organizational measures to protect your personal data. However, no method of transmission over the Internet is 100% secure.
      </p>

      <hr />

      <h2>7. Children's Privacy</h2>
      <p>
        Our services are not intended for individuals under the age of 13. We do not knowingly collect data from children.
      </p>

      <hr />

      <h2>8. International Transfers</h2>
      <p>
        If you are accessing our services from outside the country where our servers are located, your data may be transferred across borders and processed in different countries.
      </p>

      <hr />

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
      </p>

      <hr />

      <h2>10. Contact Us</h2>
      <p>If you have any questions or concerns about this Privacy Policy or how your data is handled, contact us:</p>
      <p>
        <strong>Eshop Privacy Team</strong><br />
        Email: <a href="mailto:privacy@slipmart.com">privacy@slipmart.com</a><br />
        Phone: +91 7908289795
      </p>

    </div>
  );
}

